import { Button } from "@mantine/core";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";

import { useDeleteUser, useGetCurrentUser } from "../../api/user";
import { useDeleteConfirm } from "../../hooks/useDeleteConfirm";
import { clearAuthSession } from "../../services/authStore";
import { AuthContext } from "../../services/context";
import { queryClient } from "../../services/react-query";

export default function DeleteAccountButton() {
  const navigate = useNavigate();
  const { setUser } = useContext(AuthContext);
  const { data: user } = useGetCurrentUser();

  const { mutate } = useDeleteUser(user?.id);
  const confirmDelete = useDeleteConfirm("account", mutate);

  const handleDelete = () =>
    confirmDelete(
      {},
      {
        onSuccess: () => {
          clearAuthSession();
          setUser(null);
          queryClient.clear();
          navigate("/login");
        },
      }
    );

  return (
    <Button
      onClick={handleDelete}
      disabled={!user?.id}
      color="red"
      variant="outline"
    >
      Delete account
    </Button>
  );
}
